import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ConfirmDialog } from './ConfirmDialog';

interface BlockMemberDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  memberName: string;
  isLoading?: boolean;
}

export const BlockMemberDialog: FC<BlockMemberDialogProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  memberName,
  isLoading = false,
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      isOpen={isOpen}
      title={t('community.action_menu.block_member_confirm_title', { memberName })}
      description={t('community.action_menu.block_member_confirm_description')}
      confirmLabel={t('community.action_menu.block_member_confirm_button')}
      onConfirm={onConfirm}
      onCancel={onCancel}
      isDestructive
      isLoading={isLoading}
    />
  );
};
